import get from 'lodash/get';

export const mapPrincipalCommunityApps = (communityApps = []) =>
  communityApps.map(ca => {
    const splittedApp = ca.app?.split('_');
    const appInstallationTag = get(splittedApp, '[0]');
    const communityTag = get(splittedApp, '[1]');

    return {
      appInstallation: { tag: appInstallationTag },
      community: { tag: communityTag },
      communityAppFeatures: (ca.features || []).map(f => ({
        appInstallationFeature: { tag: f.feature },
        communityAppFeatureRoles: (f.roles || []).map(r => ({
          appInstallationFeatureRole: { tag: r },
        })),
      })),
    };
  });
